var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.session.application === _vm.Consts.APPLICATION.BEESECURE)?_c('div',[_c('v-subheader',[_vm._v(" Comment ")]),_c('div',{staticClass:"font-weight-light subheading",attrs:{"layout":"row"}},[_vm._v(" "+_vm._s(_vm.session.comments)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }